import { ReactElement } from 'react';
import { useOnFieldChange } from '@ff-it/form';
import { useForm } from 'react-final-form';
import { createOptions } from 'options';
import { SearchFilterInput } from 'components/filters/SearchFilterInput';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { DateRangeFilterChip } from 'components/filters/DateRangeFilterChip';

const periodFilter = ['ONGOING', 'ENDED', 'CUSTOM'] as const;

const periodOptions = createOptions(periodFilter, {
  ONGOING: 'Ongoing',
  ENDED: 'Ended',
  CUSTOM: 'Custom',
});

export function Filter(): ReactElement {
  const form = useForm();
  const period = useOnFieldChange(
    'period',
    (value) => {
      if (value !== 'CUSTOM' && form.getState().values.date_from) {
        form.batch(() => {
          form.change('date_from', null);
          form.change('date_to', null);
        });
      }
    },
    false,
  );

  return (
    <>
      <SearchFilterInput />
      <SelectFilterChip name="period" options={periodOptions} defaultValueLabel="All" />
      {period === 'CUSTOM' && <DateRangeFilterChip label="Range" fromName="date_from" toName="date_to" />}
    </>
  );
}
